import Components from './../Component';

export default class Accordion extends Components {

  constructor($) {
    super($);
  }

  init(index, element) {
    this.$(element).find('.accordion-item').each(function (index, item) {
      this.$(item).find('.accordion-item-title').on('click', function (e) {
        this.toggle(element, item);
        e.preventDefault();
      }.bind(this));
    }.bind(this));
  }

  toggle(element, item) {
    var active = this.$(element).find('.open');

    if (!active.is(this.$(item))) {
      this.close(active);
      this.open(item);
    } else {
      this.close(item);
    }
  }

  open(item) {
    this.$(item).addClass('open');
    if (this.$(item).find('*[data-autoload="false"]')){
      console.log('load');
      this.$(item).find('.refresh').click();
    }
  }

  close(item) {
    this.$(item).removeClass('open');
  }
}